import React, { useRef, useEffect, useState } from 'react';
import './RequesterSideDrawer.css';
import './RequestRejectedModal.css';
import spotIcon from '../assets/images/spot.png';
import timeIcon from '../assets/images/time.png';
import costIcon from '../assets/images/cost.png';
import commentsIcon from '../assets/images/comments.png';
import carIcon from '../assets/images/car.png';
import plateIcon from '../assets/images/plate.png';
import emitter from '../utils/emitter';
import OwnerDetailsModal from './OwnerDetailsModal';
import { carSizeLabel } from '../utils/carSize';

const RequesterSideDrawer = ({ spot, formatRemainingTime, onCancelRequest, hasPendingRequest, isAcceptedSpot, ownerCarDetails, onClose, onRejected, onOpenChat, unreadMessages, userLocation, addNotification, currentTime, arrivalRejectedSpotId }) => {
  const drawerRef = useRef(null);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [rejectedSpot, setRejectedSpot] = useState(null);
  const [ownerUsername, setOwnerUsername] = useState('');
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [ownerDetails, setOwnerDetails] = useState(null);

  useEffect(() => {
    if (arrivalRejectedSpotId && spot && arrivalRejectedSpotId === spot.id) {
    }
  }, [arrivalRejectedSpotId, spot]);

  const handleOwnerClick = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`http://localhost:3001/api/users/username/${spot.username}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setOwnerDetails(data);
        setShowOwnerModal(true);
      } else {
        console.error('Failed to fetch owner details');
      }
    } catch (error) {
      console.error('Error fetching owner details:', error);
    }
  };

  useEffect(() => {
  }, [spot]);

  useEffect(() => {
    const handleRequestRejected = (data) => {
      if (spot && spot.id === data.spotId) {
        setRejectedSpot(spot);
        setOwnerUsername(data.ownerUsername);
        setShowRejectedModal(true);
      }
    };

    emitter.on('request-rejected', handleRequestRejected);

    return () => {
      emitter.off('request-rejected', handleRequestRejected);
    };
  }, [spot]);

  const handleCloseRejectedModal = () => {
    setShowRejectedModal(false);
    if (rejectedSpot) {
      onRejected(rejectedSpot.id);
    }
  };

  useEffect(() => {
    if (spot) {
      const remainingTime = formatRemainingTime(spot.declared_at, spot.time_to_leave);
      if (remainingTime === 'Expired') {
        onClose();
      }
    }
  }, [spot, formatRemainingTime, onClose, currentTime]);

  return (
    <>
      <div ref={drawerRef} className={`requester-side-drawer ${spot ? 'open' : ''}`}>
        <div className="requester-side-drawer-header">
          <h3>Spot Details</h3>
          <button className="close-button" onClick={onClose}>X</button>
        </div>
        {spot && (
          <>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <div className="requester-side-drawer-content">
                <div className="spot-details-grid">
                  <div><img src={spotIcon} alt="Spot" style={{ width: '24px', height: '24px' }} /></div>
                  <div className="spot-detail-text">
                    <strong>Declared by: </strong>
                    <button onClick={handleOwnerClick} style={{ background: 'none', border: 'none', padding: 0, color: 'var(--color-brand)', cursor: 'pointer', font: 'inherit' }}>
                      {spot.username}
                    </button>
                  </div>
                  {/* 2026-11-01: the owner's leaving time decides nothing once you are accepted. */}
                  {!isAcceptedSpot && (
                    <><div><img src={timeIcon} alt="Time" style={{ width: '24px', height: '24px' }} /></div><div className="spot-detail-text"><strong>Time to Expire: </strong> {formatRemainingTime(spot.declared_at, spot.time_to_leave)}</div></>
                  )}
                  <div><img src={costIcon} alt="Cost" style={{ width: '28.8px', height: '28.8px' }} /></div><div className="spot-detail-text"><strong>Cost Type: </strong> {spot.cost_type}</div>
                  {isAcceptedSpot && ownerCarDetails && (
                    <>
                      <div><img src={carIcon} alt="Car" style={{ width: '24px', height: '24px' }} /></div><div className="spot-detail-text"><strong>Car Color: </strong> {ownerCarDetails.car_color}</div>
                      <div><img src={plateIcon} alt="Plate" style={{ width: '24px', height: '24px' }} /></div><div className="spot-detail-text"><strong>{ownerCarDetails.plate_number ? 'Plate Number: ' : 'Plate ends in: '}</strong> {ownerCarDetails.plate_number || (ownerCarDetails.plate_number_partial ? `••${ownerCarDetails.plate_number_partial}` : '—')}</div>
                    </>
                  )}
                  <div><img src={commentsIcon} alt="Comments" style={{ width: '24px', height: '24px' }} /></div><div className="spot-detail-text"><strong>Comments:</strong> {spot.comments ? spot.comments : 'None'}</div>
                </div>
                <hr style={{ margin: '20px 0', borderColor: '#eee' }} />
                <div className="requests-section" style={{ padding: '0', marginTop: '-10px' }}>
                  <h3>Approvals</h3>
                  {isAcceptedSpot ? (
                    <div className="request-item accepted">
                      <div className="requester-avatar accepted">
                        <i className="fas fa-user-check"></i>
                      </div>
                      <div className="request-details">
                        <div className="requester-username accepted" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                          <span>Accepted by {spot.username}</span>
                          <div style={{ position: 'relative' }}>
                            <span className="chat-symbol" onClick={() => onOpenChat({ id: spot.user_id, username: spot.username })}>💬</span>
                            {unreadMessages && unreadMessages[spot.user_id] && <span className="unread-indicator"></span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="no-approvals-text">No approvals yet.</p>
                  )}
                </div>
              </div>
              <p style={{ color: 'var(--ink)', display: 'flex', alignItems: 'center', paddingLeft: '1rem', marginTop: 'auto' }}> {carSizeLabel(spot.car_type)}</p>
            </div>
            {/* 2026-10-17: Request and Arrived are gone from the web; Cancel stays.
                Asking for a space commits you to drive to it, and "I've arrived" is a claim about
                where your body is — neither is a thing a browser on a desk can honestly say, and
                both cost the owner a wait if they are wrong. Cancelling is the opposite: it
                releases the owner, and doing it the moment you change your mind is the kindest
                thing in the flow. */}
            <div className="requester-side-drawer-footer">
              {hasPendingRequest || isAcceptedSpot ? (
                <button type="button" onClick={() => onCancelRequest(spot.id)} className="btn btn--danger-quiet btn--block">
                  {isAcceptedSpot ? 'Give up this space' : 'Cancel request'}
                </button>
              ) : (
                <p className="drawer-phone-hint">Ask for this space from your phone — you’ll need to be driving to it.</p>
              )}
            </div>
          </>
        )}
      </div>
      {showRejectedModal && (
        <div className="request-rejected-modal-overlay">
          <div className="request-rejected-modal-content">
            <h2>Request Rejected</h2>
            <p>{`User ${ownerUsername} has unfortunately rejected your parking request`}</p>
            <button type="button" className="btn btn--secondary" onClick={handleCloseRejectedModal}>Close</button>
          </div>
        </div>
      )}
      {showOwnerModal && <OwnerDetailsModal owner={ownerDetails} onClose={() => setShowOwnerModal(false)} onOpenChat={onOpenChat} />}
    </>
  );
};

export default RequesterSideDrawer;